import {loadable} from "jotai/utils";
import {atomWithRefresh} from "../utils/jotaiUtils";
import {activeCompanyIdAtom} from "./activeCompanyStore";
import {FarmUnitData, Parcel} from "../types/domain/parcel";
import {getCompanyMaderaFarmUnits, getCompanyMaderaParcelsByFarmId} from "../services/companyService";
import {activeMergedFarmIds} from "./activeMergedFarmIds";

export const activeFarmMaderaParcelsAtom = atomWithRefresh(async (get) => {
    const activeCompanyId = await get(activeCompanyIdAtom);
    const farmIds = get(activeMergedFarmIds);
    const parcels: Parcel[] = [];

    if (activeCompanyId && farmIds?.length > 0) {
        await Promise.all(
            farmIds.map((farmId) =>
                getCompanyMaderaParcelsByFarmId(activeCompanyId, farmId).then((res) => parcels.push(...res)),
            ),
        );
    }

    return parcels;
});

export const activeFarmMaderaParcelsLoadable = loadable(activeFarmMaderaParcelsAtom);

export const activeMaderaFarmUnitsAtom = atomWithRefresh(async (get) => {
    const activeCompanyId = await get(activeCompanyIdAtom);
    let data: FarmUnitData[] = [];

    if (activeCompanyId) {
        data = await getCompanyMaderaFarmUnits(activeCompanyId);
    }

    return data;
});

export const activeMaderaFarmUnitsLoadable = loadable(activeMaderaFarmUnitsAtom);
